import { createAction } from "typesafe-actions";
import { domain } from "./types.js";
const getViewActions = () => ({
  init: createAction(`${domain}/init`)(),
  close: createAction(`${domain}/close`)(),
  save: createAction(`${domain}/save`)(),
  saveFilter: createAction(`${domain}/saveFilter`)(),
  saveKeys: createAction(`${domain}/saveKeys`)(),
  updateFilter: createAction(`${domain}/updateFilter`)(),
  updateKeys: createAction(`${domain}/updateKeys`)(),
  updateCleanDelay: createAction(`${domain}/updateCleanDelay`)(),
  clean: createAction(`${domain}/clean`)(),
  update: createAction(`${domain}/update`)(),
  collectGarbage: createAction(`${domain}/collectGarbage`)(),
  markUsed: createAction(`${domain}/markUsed`)(),
  markUnused: createAction(`${domain}/markUnused`)(),
  refreshSubscription: createAction(`${domain}/refreshSubscription`)(),
  pause: createAction(`${domain}/pause`)(),
  resume: createAction(`${domain}/resume`)(),
  changeIsInitialized: createAction(`${domain}/changeIsInitialized`)()
});
export {
  getViewActions
};
//# sourceMappingURL=actions.js.map
